import styled from '@emotion/styled';
import Icon from '@mdi/react';
import { Variables } from '../base/variables/variables';

export const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;

export const ListHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ListTitle = styled.span`
    font-size: 16px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
`;

export const ListSubtitle = styled.span`
    font-size: 13px;
    color: ${Variables.Colors.n50};
`;

export const ItemList = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${Variables.Colors.nx8};
    border-radius: 4px;
    background-color: ${Variables.Colors.nx4};
    max-height: min(60vh, 480px);
    overflow-y: auto;
`;

export const ItemRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 12px;
    border-bottom: 1px solid ${Variables.Colors.n5};

    &:last-of-type {
        border-bottom: none;
    }
`;

export const StatusIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-top: 2px;
`;

export const StatusIcon = styled(Icon)<{ $color?: string }>`
    width: 18px;
    height: 18px;
    color: ${({ $color }) => $color || Variables.Colors.n50};
    fill: ${({ $color }) => $color || Variables.Colors.n50};
`;

export const ItemContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex: 1;
`;

export const ItemHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const ItemFileName = styled.span`
    font-size: 14px;
    color: ${Variables.Colors.n100};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
`;

export const ItemStatusLabel = styled.span<{ $status: 'pending' | 'uploading' | 'success' | 'failed' | 'cancelled' }>`
    font-size: 13px;
    font-weight: 500;
    flex-shrink: 0;
    color: ${({ $status }) => {
        switch ($status) {
            case 'success':
                return Variables.Colors.successful;
            case 'failed':
                return Variables.Colors.warning;
            case 'uploading':
                return Variables.Colors.p100;
            case 'cancelled':
                return Variables.Colors.n50;
            default:
                return Variables.Colors.n50;
        }
    }};
`;

export const ItemErrorMessage = styled.span`
    font-size: 12px;
    color: ${Variables.Colors.warning};
    line-height: 1.4;
`;
